import { App } from 'vue';
import clickOutsideDirective from '@/common/directives/click-outside.directive';

export default function setDirectives(app: App<Element>): void {
  app.directive('click-outside', clickOutsideDirective);
  // app.directive('focus', focusDirective);
}
